import { enableProdMode, LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { withInterceptorsFromDi, provideHttpClient, withXhr } from '@angular/common/http';
import { Title, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withRouterConfig } from '@angular/router';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';

import { provideClarity } from 'ngx-clarity';

import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeNor from '@angular/common/locales/nb';
import localeNorExtra from '@angular/common/locales/extra/nb';

// import { enableAkitaProdMode } from '@datorama/akita';

import { environment } from '@gan/core/util-environment';
import { APP_ROUTES } from './app/app-routes';
import { AppComponent } from './app/app.component';

import { provideTitle } from '@gan/shared/ui-title';
import { provideLucidIcons } from '@gan/shared/ui-icon';
import { provideApplicationVersion } from '@gan/core/feature-application-version';
import { provideLocalStorage } from '@gan/core/util-local-storage';
import { provideDateTimeHelper } from '@gan/core/util-date-time-helper';
import { LanguageService, provideLanguage } from '@gan/core/feature-language';
import { provideUser } from '@gan/common/data-user';
import { provideAuth } from '@gan/common/feature-auth';
import { OrientationService } from '@gan/shared/ui-orientation-toggle';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeEn, 'en');
registerLocaleData(localeNor, 'no', localeNorExtra);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideLanguage(),
    provideLocalStorage(),
    provideApplicationVersion(),
    provideDateTimeHelper(),
    provideUser(),
    provideAuth(),
    provideLucidIcons(),
    ...(environment.production ? [] : [importProvidersFrom(AkitaNgDevtools.forRoot())]),
    // Angular 21's default; 22's 'always' would also give child routes their parents' params and data
    provideRouter(APP_ROUTES, withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' })),
    provideTitle(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !environment.APP_URL.includes('localhost'),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:5000',
    }),
    Title,
    {
      provide: LOCALE_ID,
      useFactory: (storage: LanguageService) => storage.getLang(),
      deps: [LanguageService],
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' },
    },
    provideClarity({
      enabled: environment.CLARITY_PROJECT_ID.length > 0,
      projectId: environment.CLARITY_PROJECT_ID,
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimations(),
    OrientationService,
  ],
}).catch((err) => console.error(err));

// Akita
// if (environment.production) {
//   enableAkitaProdMode();
// }
